(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b365-story-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b365-story-carousel')) {
    class B365StoryCarousel extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (!this.track || !this.slides.length) return;
        this.tabs = [...this.querySelectorAll('[data-progress]')];
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.counter = this.querySelector('[data-current]');
        this.status = this.querySelector('[data-status]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.index = 0;
        this.mobileQuery = matchMedia('(max-width: 989px)');
        this.mobileQuery.addEventListener('change', () => this.syncLayout(), options);
        this.carouselInView = false;
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.carouselInView = entries.some(entry => entry.isIntersecting);
          this.updateContactVisibility();
        });
        this.visibilityObserver.observe(this);
        this.querySelector('[data-navigation]').hidden = this.slides.length < 2;
        this.dataset.enhanced = 'true';
        this.slides.forEach((slide, index) => {
          slide.setAttribute('role', 'tabpanel');
          if (this.tabs[index]) slide.setAttribute('aria-labelledby', this.tabs[index].id);
        });
        this.previous.addEventListener('click', () => this.goTo(this.index - 1), options);
        this.next.addEventListener('click', () => this.goTo(this.index + 1), options);
        this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.goTo(index), options));
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.settle(), 140);
        }, { ...options, passive: true });
        this.track.addEventListener('scrollend', () => this.settle(), options);
        this.addEventListener('keydown', event => this.onKeydown(event), options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === String(event.detail.blockId));
          if (index >= 0) this.goTo(index, false, false);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (!this.isConnected) return;
            this.syncLayout();
            this.track.scrollTo({ left: this.offsetFor(this.index), behavior: 'instant' });
          });
        });
        this.resizeObserver.observe(this.track);
        this.syncLayout();
        this.activate(0, false);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.carouselInView = false;
        this.removeAttribute('data-mobile-in-view');
        cancelAnimationFrame(this.resizeFrame);
        clearTimeout(this.settleTimer);
      }

      syncLayout() {
        const focused = this.contains(document.activeElement) ? document.activeElement : null;
        const mobile = this.mobileQuery.matches;
        this.updateContactVisibility();
        this.slides.forEach((slide, index) => {
          const story = slide.querySelector('.b365-stories__story');
          const title = slide.querySelector('.b365-stories__title');
          const purchase = slide.querySelector('.b365-stories__purchase');
          const price = purchase?.querySelector('.b365-stories__price');
          if (purchase && story && title) {
            if (mobile) {
              if (title.nextElementSibling !== purchase) title.after(purchase);
              if (price && purchase.firstElementChild !== price) purchase.prepend(price);
            } else {
              if (story.lastElementChild !== purchase) story.append(purchase);
              if (price && purchase.lastElementChild !== price) purchase.append(price);
            }
          }
          if (mobile && index !== this.index) {
            slide.querySelectorAll('details[open]').forEach(details => { details.open = false; });
          }
        });
        const imageSize = `${this.track.clientWidth}px`;
        if (this.style.getPropertyValue('--b365-mobile-image-size') !== imageSize) {
          this.style.setProperty('--b365-mobile-image-size', imageSize);
        }
        if (focused && (document.activeElement !== focused || !focused.getClientRects().length)) {
          const target = focused.getClientRects().length ? focused : this.track;
          target.focus({ preventScroll: true });
        }
      }

      updateContactVisibility() {
        this.toggleAttribute('data-mobile-in-view', this.mobileQuery.matches && this.carouselInView);
      }

      activate(index, announce = true) {
        if (index !== this.index && this.mobileQuery.matches) {
          const outgoing = this.slides[this.index];
          if (outgoing.contains(document.activeElement)) this.track.focus({ preventScroll: true });
          outgoing.querySelectorAll('details[open]').forEach(details => { details.open = false; });
        }
        this.index = index;
        this.slides.forEach((slide, position) => {
          const active = position === index;
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
          if (this.tabs[position]) {
            this.tabs[position].setAttribute('aria-selected', String(active));
            this.tabs[position].tabIndex = active ? 0 : -1;
          }
        });
        this.previous.disabled = index === 0;
        this.next.disabled = index === this.slides.length - 1;
        this.counter.textContent = String(index + 1).padStart(2, '0');
        if (announce && this.status) {
          this.status.textContent = this.dataset.statusTemplate
            .replace('[number]', String(index + 1))
            .replace('[total]', String(this.slides.length))
            .replace('[title]', this.slides[index].dataset.title);
        }
      }

      goTo(index, focusTab = false, animate = true) {
        if (index < 0 || index >= this.slides.length) return;
        this.activate(index);
        this.track.scrollTo({
          left: this.offsetFor(index),
          behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'
        });
        if (focusTab) this.tabs[index]?.focus({ preventScroll: true });
      }

      settle() {
        clearTimeout(this.settleTimer);
        if (!this.track.clientWidth) return;
        const index = Math.max(0, Math.min(this.slides.length - 1, Math.round(Math.abs(this.track.scrollLeft) / this.track.clientWidth)));
        if (index !== this.index) this.activate(index);
      }

      offsetFor(index) {
        return index * this.track.clientWidth * (getComputedStyle(this.track).direction === 'rtl' ? -1 : 1);
      }

      onKeydown(event) {
        if (event.altKey || event.ctrlKey || event.metaKey || event.target.closest('a, summary, input, textarea, select, [contenteditable="true"]')) return;
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        let index;
        if (event.key === 'ArrowRight') index = this.index + direction;
        if (event.key === 'ArrowLeft') index = this.index - direction;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.slides.length - 1;
        if (index === undefined) return;
        event.preventDefault();
        this.goTo(Math.max(0, Math.min(this.slides.length - 1, index)), Boolean(event.target.closest('[data-progress]')));
      }
    }
    customElements.define('b365-story-carousel', B365StoryCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
